import { render, staticRenderFns } from "./DuplicateCustomerIndex.vue?vue&type=template&id=7ae6eb3c&scoped=true&"
import script from "./DuplicateCustomerIndex.vue?vue&type=script&lang=js&"
export * from "./DuplicateCustomerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae6eb3c",
  null
  
)

export default component.exports